export const doLog = (...text) =>{
    const isLogging = true;

    if(isLogging)
        console.log(...text)
}